import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form/immutable"

import ExplainedToggleField from "app/static/frontend/forms/components/ExplainedToggleField"
import GridToggleSelectField from "app/static/frontend/forms/components/GridToggleSelectField"
import SearchifySelectField from "app/static/frontend/forms/containers/SearchifySelectField"
import { ContactSelect, UserSelect } from "app/static/frontend/selects/containers/PieSelect"

import { BULK_ACTIONS_FORM_KEY } from "shared/imports/sharedConstants"
import { constants } from "shared/forms/BulkActions/constants"

// generic component
const BulkActionsAssign = (props) => {
    const isSupporterAssignmentType =
        props.assignmentInputType === DjangIO.app.search.bulkactions.types.AssignmentInputType.supporter.value
    const isUserAssignmentType =
        props.assignmentInputType === DjangIO.app.search.bulkactions.types.AssignmentInputType.user.value

    return (
        <div className="bulk-actions-console-assign-form" data-cy="bulk-actions-console-assign-form">
            <Field
                allowNull={false}
                choices={DjangIO.app.search.bulkactions.types.AssignmentSelectType.items().sort(DjangIO.valueSort)}
                className="bulk-actions-form-assignment-select"
                component={GridToggleSelectField}
                dropUp={false}
                multi={false}
                name="assignment_select_type"
            />

            {
                // the input type is only relevant when we are not clearing all Assignments
                props.assignmentSelectType !==
                    DjangIO.app.search.bulkactions.types.AssignmentSelectType.clear.value && (
                    <Field
                        allowNull={false}
                        choices={DjangIO.app.search.bulkactions.types.AssignmentInputType.items().sort(
                            DjangIO.valueSort
                        )}
                        className="bulk-actions-form-assignment-input-type"
                        component={GridToggleSelectField}
                        dropUp={false}
                        multi={false}
                        name="assignment_input_type"
                    />
                )
            }
            {isUserAssignmentType &&
                props.assignmentSelectType !==
                    DjangIO.app.search.bulkactions.types.AssignmentSelectType.clear.value && (
                    <Field
                        key="users"
                        // the name/key that will be stored in the reduxForm Immutable map
                        name="users"
                        // the tooltip hover text that will be displayed to the right of the label
                        tooltipText="Choose the team members to assign."
                        className="bulk-actions-form-users"
                        data-cy="bulk-actions-form-users"
                        component={SearchifySelectField}
                        selectComponent={UserSelect}
                        props={{
                            // change is inherited from the reduxForm() wrapper in
                            // app/static/frontend/search-new/containers/BulkActions/BulkActionsConsole
                            change: props.change,
                            dataCy: "bulk-actions-form-users",
                            formKey: BULK_ACTIONS_FORM_KEY,
                            model: DjangIO.app.userdata.models.QuorumUser,
                            name: "users",
                        }}
                        customProps={constants.CUSTOM_SEARCHIFY_FORM_PROPS_MULTI}
                    />
                )}
            {isSupporterAssignmentType &&
                props.assignmentSelectType !==
                    DjangIO.app.search.bulkactions.types.AssignmentSelectType.clear.value && (
                    <Field
                        key="supporters"
                        // the name/key that will be stored in the reduxForm Immutable map
                        name="supporters"
                        // the tooltip hover text that will be displayed to the right of the label
                        tooltipText="Choose the contacts to assign."
                        className="bulk-actions-form-supporters"
                        data-cy="bulk-actions-form-supporters"
                        component={SearchifySelectField}
                        selectComponent={ContactSelect}
                        props={{
                            // change is inherited from the reduxForm() wrapper in
                            // app/static/frontend/search-new/containers/BulkActions/BulkActionsConsole
                            change: props.change,
                            dataCy: "bulk-actions-form-supporters",
                            formKey: BULK_ACTIONS_FORM_KEY,
                            model: DjangIO.app.grassroots.models.Supporter,
                            name: "supporters",
                        }}
                        customProps={constants.CUSTOM_SEARCHIFY_FORM_PROPS_MULTI}
                    />
                )}
            {
                // whether or not this is a primary assignment is only relevant when we are setting one user
                isUserAssignmentType &&
                    props.assignmentSelectType ===
                        DjangIO.app.search.bulkactions.types.AssignmentSelectType.add.value && (
                        <Field
                            component={ExplainedToggleField}
                            name="primary"
                            on="Is Primary"
                            onExplanation="This will be a primary assignment"
                            off="Is Not Primary"
                            offExplanation="This will not be a primary assignment"
                        />
                    )
            }
        </div>
    )
}

BulkActionsAssign.propTypes = {
    // from app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsAssign
    assignmentInputType: PropTypes.number,
    assignmentSelectType: PropTypes.number,
    // from app/static/frontend/search-new/components/BulkActions/BulkActionsConsole
    change: PropTypes.func.isRequired,
}

export default BulkActionsAssign
